import "./StyledSelect.css";
import React, { SelectHTMLAttributes } from "react";

export interface StyledSelectProps
    extends SelectHTMLAttributes<HTMLSelectElement> {
    label?: string; // optional, if you ever want one
}

const StyledSelect = ({ label, children, ...props }: StyledSelectProps) => {
    return (
        <div className="styledselect-container">
            {label && <label className="styledselect-label">{label}</label>}

            <div className="styledselect-wrapper">
                <select className="styledselect" {...props}>
                    {children}
                </select>
            </div>
        </div>
    );
};

export default StyledSelect;
